import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gray-50">
    <div className="flex flex-col items-center justify-center text-center py-10 min-h-[50vh]">
      <h2 className="text-2xl font-bold text-red-600 mb-4">404 - Page Not Found</h2>
      <p className="text-gray-700 mb-6">The page you requested does not exist.</p>
      <Link
        to="/"
        className="inline-block bg-blue-500 text-white px-5 py-2 rounded-md text-base font-semibold hover:bg-blue-600 transition"
      >
        Return to Home
      </Link>
    </div>
    </div>
  );
}
